// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"318":"60ce2b0d","536":"f5c71531"}[chunkId] + ".chunk.css";
};